<template>
    <div class="wrapper">
        <div class="banner" v-if="noHeader">
            <el-carousel arrow="never" height="400px">
                <el-carousel-item v-for="(item,index) in bannerList" :key="index">
                    <div class="pic_item">
                        <img :src="item.url" style="" class="img">
                        <h3>{{ item.title }}>></h3>
                    </div>
                </el-carousel-item>
            </el-carousel>
        </div>
        <div class="msg-box center-wrapper">
            <JewelsMeaasge :dataList="newsList" :key="num"/>
        </div>
        <div class="all-trade center-wrapper">
            <!-- <el-button type="primary">全部资讯</el-button> -->
            <p class="allNews">全部资讯</p>
            <hr>
            <div class="detail-item" v-for="(item,index) in newsList" :key="index" @click="newsDetail(item)">
                <div >
                    <img class="detail-img" :src="item.img_url" alt="">
                </div>
                <div class="word-box">
                    <h1>{{ item.title }}</h1>
                    <p v-html="item.content"></p>
                    <div class="sub-box">
                        <div>
                            <img src="../assets/img/seeIcon.png" alt="">
                            <span>{{ item.views }}阅读</span>
                        </div>
                        <div>{{ item.create_date }}</div>
                    </div>
                </div>
            </div>
            <div class="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync="currentPage"
                    :page-size="10"
                    layout="prev, pager, next, jumper"
                    prev-text="上一页"
                    next-text="下一页"
                    :total="total"
                    ref="pageGroup"
                >
                </el-pagination>
            </div>

        </div>
    </div>
</template>

<script>
import JewelsMeaasge from "../components/JewelsMeaasge.vue";
import {fetchNewspmList, newsList} from '@/api/api';

export default {
    name: 'Trade',
    components: {
        JewelsMeaasge,
    },
    props: {
        noHeader: {
            type: Boolean,
            default: true
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {     //因为当钩子执行前，组件实例还没被创建
            //vm 就是当前组件的实例相当于上面的 this，所以在 next 方法里你就可以把 vm 当 this 来用了。
            console.log('vm:', vm)
            if (from.name == "articleContent") {  //如果从详情页回来
                vm.$store.commit('SET_KEEP_ALIVE', ['Trade']);  //缓存
            } else {
                vm.$store.commit('SET_KEEP_ALIVE', []);
            }
            console.log(vm.$store.state.KEEPALIVES)
        })
    },

    //离开该组件的对应路由时调用
    beforeRouteLeave(to, from, next) {
        if (to.name == "articleContent") {
            this.$store.commit('SET_KEEP_ALIVE', ['Trade']);
        } else {
            this.$store.commit('SET_KEEP_ALIVE', []);
        }
        next();
    },
    data() {
        return {
            bannerList: [
                {
                    url: require('../assets/img/tradeBn.png'),
                    title: '占全球原钻产量三成的俄罗斯钻石遭珠宝行业'
                },
                {
                    url: require('../assets/img/tradeBn.png'),
                    title: '占全球原钻产量三成的俄罗斯钻石遭珠宝行业'
                },
                {
                    url: require('../assets/img/tradeBn.png'),
                    title: '占全球原钻产量三成的俄罗斯钻石遭珠宝行业'
                },
            ],
            newsList: [],
            currentPage: 1,
            size: 12,
            total: 0,
            num: 0,
        };
    },
    watch: {},
    computed: {},
    created() {
        this.readList()
    },
    mounted() {
    },
    methods: {
        readList() {
            newsList({per_page: this.size, page: this.currentPage}).then(r => {
                if (r.data?.data.length) {
                    this.newsList = r.data.data.map(item => {
                        item.content = item.content.replace(/&lt;/ig, '<').replace(/&gt;/ig, '>').replace(/&quot;/ig, '"').replace(/&amp;nbsp;/ig, ' ').replace(/<[^>]+>/g, "")
                        return item
                    })
                    this.total = Number(r.data.count);
                } else {
                    this.newsList = [];
                }
                this.num = 1;

            })
        },
        newsDetail(item) {
            this.$router.push({path: '/articleContent', query: {articleId: item.id,}});
        },
        handleSizeChange(e) {
            this.size = e
            this.readList()
        },
        handleCurrentChange(e) {
            this.currentPage = e
            this.readList()
        },

    }
};
</script>
<style lang="scss" scoped>
.wrapper {
    background: rgb(240, 240, 240);

    .banner {
        width: 100%;
        height: 400px;
        position: relative;
        overflow: hidden;

        .pic_item {
            height: 100%;
            width: 100%;
        }

        .el-carousel__item h3 {
            color: white;
            font-size: 30px;
            font-weight: 700;
        }

        .img {
            height: 100%;
            width: 100%;
            object-fit: cover;
        }

        h3 {
            position: absolute;
            left: 22rem;
            bottom: 2rem;
        }
    }

    .banner ::v-deep .el-carousel__indicator--horizontal .el-carousel__button {
        width: 10px;
        height: 10px;
        background: transparent;
        border: 1px solid #ffffff;
        border-radius: 50%;
        opacity: 0.5;
    }

    .banner ::v-deep .el-carousel__indicator--horizontal.is-active .el-carousel__button {
        width: 10px;
        height: 10px;
        background: #ffffff;
        border-radius: 50%;
        opacity: 1;
    }

    .banner ::v-deep .el-carousel__indicators {
        left: unset;
        transform: unset;
        right: 20%;
    }

    .msg-box {
        box-sizing: content-box;
        height: 460px;
        padding-top: 50px;
        padding-bottom: 50px;
    }

    .all-trade {
        .allNews {
            font-size: 18px;
            font-weight: 400;
            padding: 0 0 10px 20px;
            color: rgba(26, 26, 26, 1);
        }

        hr {
            color: rgba(204, 204, 204, 1);
        }

        .detail-item {
            height: 210px;
            background: #ffffff;
            padding: 30px;
            display: flex;
            //  justify-content: space-between;
            align-items: center;
            border-radius: 14px;
            margin-top: 20px;

            .detail-img {
                object-fit: cover;
                height: 160px;
                width: 160px;
                overflow: hidden;
                border-radius: 10px;

            }

            .word-box {
                padding-left: 30px;
                text-align: left;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: flex-start;

                .sub-box {
                    display: flex;
                    width: 100%;
                    justify-content: space-between;
                }

                h1 {
                    font-size: 24px;
                    font-weight: 700;
                    cursor: default;
                }

                p {
                    font-size: 16px;
                    font-weight: 400;
                    line-height: 22px;
                    color: rgba(114, 113, 113, 1);
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 3;
                    -webkit-box-orient: vertical;
                }

                div {
                    display: flex;
                    align-items: center;
                    font-size: 14px;
                    font-weight: 400;
                    color: #a6a6a6;
                    padding: 5px;

                    span {
                        font-size: 14px;
                        font-weight: 400;
                        color: rgba(166, 166, 166, 1);
                        margin-left: 10px;
                    }
                }
            }
        }

        .pagination {
            position: sticky;
            text-align: center;
            padding: 50px 0 70px 0;
        }
    }


    ::v-deep .el-pagination .btn-next, ::v-deep .el-pagination .btn-prev, ::v-deep .el-pager li.active {
        background: #2093ca;
        color: #ffffff;
    }

    .el-button {
        background: #2093ca;
    }

    ::v-deep .el-pager li {
        margin: 0 3px;
        border: 0.86px solid rgba(204, 204, 204, 1);
    }

    ::v-deep .el-pagination .btn-prev, ::v-deep .el-pagination .btn-next {
        border: 0.86px solid rgba(204, 204, 204, 1);
    }
}
</style>